import { useDroppable } from '@dnd-kit/core';

interface DroppableContainerProps {
  id: string;
  children: React.ReactNode;
}

export const DroppableContainer = ({ id, children }: DroppableContainerProps) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      style={{
        backgroundColor: isOver ? 'rgba(0, 128, 0, 0.1)' : 'transparent',
        transition: 'background-color 0.2s',
        height: '100%',
      }}
    >
      {children}
    </div>
  );
};
